import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { ReactSession } from "../../lib/secure_reactsession";
import { encryptId, renderTestTitleCreate } from "../../lib/helpers";
import { LoadingIcon } from "../themes/userq/Loader/loadingIcon";
import { Helmet } from "react-helmet";
import ScreeningQuestionsModal from "../themes/userq/ScreeningQuestionsModal/screening_questions_modal";
import { getTestData } from "../../services/test";
import BrowserNotSupported from "./elements/browser_not_supported";
import DeviceNotSupported from "./elements/device_not_supported";
import { TakingTestHeader } from "../themes/userq/Header/TakingTestHeader";
import ExitTestModal from "./dialog/exit_test_modal";
import {
  isMobileOrTabletDevice,
  isUnsupportedBrowserForScreenRecording,
  testRequiresChromeDesktop,
} from "../../lib/browserSupport";

export default function TestScreening() {
  let { test_id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const [test, setTest] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [screeningQuestionsModal, setScreeningQuestionsModal] = useState({
    open: false,
  });
  const [openExitTestModal, setOpenExitTestModal] = useState(false);

  const isUnsupportedBrowser =
    test && isUnsupportedBrowserForScreenRecording(test);
  const isUnsupportedMobileBrowser =
    test && testRequiresChromeDesktop(test) && isMobileOrTabletDevice();

  const closeExitTestModal = (confirmed) => {
    setOpenExitTestModal(false);
    if (confirmed) {
      if (ReactSession.get("token")) {
        navigate("/dashboard");
      } else {
        navigate("/tester/sign-in");
      }
    }
  };

  const renderUnsupportedBrowserScreen = () => {
    if (isUnsupportedMobileBrowser) {
      return <DeviceNotSupported withHeader />;
    }
    return <BrowserNotSupported withHeader />;
  };

  const getTestResultApi = () => {
    let token = ReactSession.get("token");

    let guest_token = ReactSession.get("guest_token");

    if (!ReactSession.get("guest_token")) {
      const randomToken = Math.random().toString(36).substr(2, 15);
      ReactSession.set("guest_token", randomToken);
      guest_token = randomToken;
    }

    setLoading(true);

    getTestData({ test_id: test_id, guest_token: guest_token }, token).then(
      (response) => {
        setLoading(false);
        if (!response.success) {
          return;
        }

        setTest(response.test);

        if (isUnsupportedBrowserForScreenRecording(response.test)) {
          return;
        }

        if (
          response.test.target_group.is_screening_questions &&
          response.test.target_group.is_screening_questions == 1
        ) {
          if (response.screeningattemptedTests.includes(response.test.id)) {
            navigate("/t/" + encryptId(response.test.id, response.test));
          } else {
            setScreeningQuestionsModal({ open: true });
          }
        } else {
          navigate("/t/" + encryptId(response.test.id, response.test));
        }
      },
    );
  };

  useEffect(() => {
    getTestResultApi();
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>
          {location.pathname.substr(1, 1) === "t"
            ? "Take Test"
            : "Preview " +
            (test && test.methodology
              ? renderTestTitleCreate(test.methodology)
              : " test")}{" "}
          | UserQ
        </title>
      </Helmet>

      <div className="tester-login-page-wrapper">
        {isLoading && (
          <div className="full-page-loader taking-test-full-page-loader">
            <LoadingIcon />
          </div>
        )}
        {!isLoading && (
          <>
            {isUnsupportedBrowser && test ? (
              <>
                <TakingTestHeader
                  test={test}
                  exitText={() => setOpenExitTestModal(true)}
                />
                <div className="fivetestmain-box fullheight-minusHF">
                  {renderUnsupportedBrowserScreen()}
                </div>
                <ExitTestModal
                  openExitTestModal={openExitTestModal}
                  closeExitTestModal={closeExitTestModal}
                  test={test}
                />
              </>
            ) : (
              screeningQuestionsModal.open &&
              test && (
                <ScreeningQuestionsModal
                  openModal={screeningQuestionsModal.open}
                  closeModal={(reloadTests) => {
                    setScreeningQuestionsModal({ open: false });
                    if (reloadTests) {
                      let token = ReactSession.get("token");
                      if (!token) {
                        navigate("/tester/sign-up");
                      } else {
                        navigate("/dashboard");
                      }
                    } else {
                      let token = ReactSession.get("token");
                      if (!token) {
                        navigate("/tester/sign-in");
                      } else {
                        navigate("/dashboard");
                      }
                    }
                  }}
                  test={test}
                  location={location.pathname.substr(1, 1)}
                />
              )
            )}
          </>
        )}
      </div>
    </>
  );
}
